<script>
import IntegrationsBase from "@/components/tools/IntegrationsBase.vue";
import ENotas from "@/components/tools/modals/ENotas.vue";
import Notazz from "@/components/tools/modals/Notazz.vue";
import Spedy from "@/components/tools/modals/Spedy.vue";
import Bling from "../../../components/tools/modals/Bling.vue";
export default {
  extends: IntegrationsBase,
  data() {
    return {
      name: "Notas fiscais",
      subtitle:
        "Integre sua plataforma de emissão de notas fiscais à " +
        this.$config.get("title")
    };
  },
  computed: {
    options() {
      return [
        {
          title: "eNotas",
          image: require("@/assets/images/integrations/enotas.svg"),
          description:
            "Integre sua Nota Fiscal com o eNotas à " +
            this.$config.get("title"),
          modal: ENotas,
          name: "enotas"
        },
        {
          title: "Notazz",
          image: require("@/assets/images/integrations/notazz.svg"),
          description:
            "Integre sua Nota Fiscal com o Notazz à " +
            this.$config.get("title"),
          modal: Notazz,
          name: "notazz"
        },
        {
          title: "Spedy",
          image: require("@/assets/images/integrations/spedy.svg"),
          description:
            "Integre sua Nota Fiscal com o Spedy à " +
            this.$config.get("title"),
          modal: Spedy,
          name: "spedy"
        },
        {
          title: "Bling",
          image: require("@/assets/images/integrations/bling.svg"),
          description:
            "Integre sua Nota Fiscal com o Bling à " +
            this.$config.get("title"),
          modal: Bling,
          name: "bling"
        }
      ];
    }
  }
};
</script>
